import { getDashboard } from "./../../shared/services/sensors.data.service";

export const getRouteData = (positionsData, unitId, reportData) => {
  const unitReportData = positionsData.units.filter((unit) => {
    return unit.info.id === unitId;
  })[0];

  return getUnitReportView(unitReportData, reportData);
};

export const getUnitReportView = (unitReportData, reportData) => {
  return {
    info: unitReportData.info,
    information: unitReportData.dashboard,
    data: unitReportData,
    tableData: getTableData(unitReportData, reportData),
  };
};

function getTableData(unitReport, reportData) {
  return {
    header: getHederByData(unitReport, reportData.fields),
    pivot: getPivotData(reportData.fields, unitReport.pivot),
    days: getDayData(unitReport, reportData),
    info: unitReport.info,
    dashboard: getDashboardData(getDashboard(reportData.dashboards, unitReport.dashboard), reportData.fields.length),
  };
}

function getHederByData(unitReport, fields) {
  if (unitReport.days.length === 0 || unitReport.days[0].rows.length === 0) {
    return [];
  }

  const keys = Object.keys(unitReport.days[0].rows[0]);

  return fields
    .map((field) => {
      if (
        keys.some((key) => {
          return key === field.dashboard.codes;
        })
      ) {
        return {
          width: field.cssColumnWidth,
          title: field.dashboard.title,
          code: field.dashboard.codes,
          measure: field.dashboard.measure,
        };
      }
    })
    .filter((x) => {
      return x !== undefined;
    });
}

function getHeaders(fields, unitReport) {
  return fields.map((field) => {
    return {
      width: field.cssColumnWidth,
      title: field.dashboard.title,
      code: field.dashboard.codes,
      measure: field.dashboard.measure,
    };
  });
}

export function getPivotData(fields, pivot, day) {
  if (pivot === null || Object.keys(pivot).length === 0) return [];

  return fields
    .map((field) => {
      let value = null;
      if (field.dashboard.codes === "TI") {
        value = day ? `Итого за ${day}:` : "Итого:";
      } else {
        value = pivot[field.dashboard.codes];
      }

      if (value !== undefined) {
        return {
          width: field.cssColumnWidth,
          value: value,
        };
      }
    })
    .filter((x) => {
      return x !== undefined;
    });
}

function getDayData(unitReport, reportData) {
  return unitReport.days.map((day) => {
    return {
      day: day.day,
      pivot: getPivotData(reportData.fields, day.pivot, day.day),
      dashboard: getDashboardData(getDashboard(reportData.dashboards, day.dashboard)),
      rows: getRows(reportData.fields, day),
    };
  });
}

function getDashboardData(dashboards) {
  const dashboardData = [];

  let rowDashboart = [];

  dashboards.forEach((element) => {
    rowDashboart.push(element);

    if (rowDashboart.length === 4) {
      dashboardData.push(rowDashboart);
      rowDashboart = [];
    }
  });

  if (rowDashboart.length > 0) {
    for (let i = rowDashboart.length; i <= 3; i++) {
      rowDashboart.push(null);
    }

    dashboardData.push(rowDashboart);
  }

  if (dashboardData.length > 1 && dashboardData[dashboardData.length - 1].length < dashboardData[dashboardData.length - 2].length) {
    const columns = dashboardData[dashboardData.length - 2].length - dashboardData[dashboardData.length - 1].length;
  }

  return dashboardData;
}

function getRows(fields, day) {
  const values = day.day !== null ? day.day.split(".") : null;

  return day.rows.map((row) => {
    const time = values !== null ? `${values[2]}-${values[1]}-${values[0]}T${row["TI"] ? row["TI"] : "00:00:00"}` : null;

    return {
      time: time,
      data: fields
        .map((field) => {
          if (row[field.dashboard.codes] !== undefined) {
            return {
              width: field.cssColumnWidth,
              value: row[field.dashboard.codes] ? row[field.dashboard.codes] : "",
            };
          }
        })
        .filter((x) => {
          return x !== undefined;
        }),
    };
  });
}
